export default "__VITE_ASSET__Cv6xUbCA__"